import * as api from '../api'
import { FETCH_ALL_LIVE, CREATE_LIVE, DELETE_LIVE, UPDATE_LIVE } from '../constants/actionTypes.js'
import { contrainteNotification, deleteContrainteNotification } from './notifications.js'

// Action creator
export const getLives = () => async (dispatch) => {

    try{
        const {data} = await api.fetchLives()

        dispatch({ type: FETCH_ALL_LIVE, payload: data})

    } catch(error){
        console.log(error.message)
    } 
}

export const createLive = (live) => async (dispatch) => {
    try {

        const { data } = await api.createLive(live)

        dispatch( { type : CREATE_LIVE, payload: data})
    } catch(error){
        console.log(error.message)
    }
}

export const createLiveByCompetitionDetails = (live) => async (dispatch) => {
    try {

        const { data } = await api.createLiveByCompetitionDetails(live)

        dispatch( { type : CREATE_LIVE, payload: data})
    } catch(error){
        console.log(error.message)
    }
}

export const updateLiveByCompetitionDetails = (id, live) => async (dispatch) => {
    try {
        const { data } = await api.updateLiveByCompetitionDetails(id, live)

        dispatch({ type : UPDATE_LIVE, payload: data})
    } catch(error){
        console.log(error.message)
    }
}

export const updateLive = (id, live, onSuccess, onError) => async (dispatch) => {
    try {
        const { data } = await api.updateLive(id, live);

        dispatch({ type: UPDATE_LIVE, payload: data });

        if (onSuccess) {
            onSuccess(data);
        }
    } catch (error) {
        console.log(error);

        if (onError) {
            onError(error);
        }
    }
}

export const deleteLive = (id, callback) => async (dispatch) => {
    try {
        await api.deleteLive(id)

        dispatch(deleteContrainteNotification(id))

        callback(id)

        dispatch({ type : DELETE_LIVE, payload: id})
    }catch(error){
        console.log(error)
        const {error : serverError} = error.response?.data

        if (serverError){
            const {statusCode, type, typeObject, idObject} = serverError

                    if(statusCode===409 && type==='constraint'){
                        // Un autre object doit etre supprimé avant
                        dispatch(contrainteNotification(idObject, typeObject))
                    }
        }

       
    }
}